import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../../components/header";
import { FormEvent, useEffect, useState } from "react";
import { ManagersApproversDeleteService, ManagersCostCentersApproversService, ManagersCostCentersCreateApproverService, ManagersCostCentersShowService, MnaagersCostCentersAddLevelService, MnaagersCostCentersRemoveLevelService } from "../../../services/managers/cost_centers";
import { ToastErro, ToastSucesso } from "../../../components/toast";
import ContainerComponent from "../../../components/conatiner";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import InputComponent from "../../../components/input";
import LoadingComponent from "../../../components/loading";
import TableComponent from "../../../components/table";
import ModalComponent from "../../../components/modal";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const ManagersCostCentersInfoPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const { id } = useParams();

    const [costCenter, setCostCenter] = useState<any>(null!);
    const [approvers, setApprovers] = useState<any>([]);
    const [isAdmin, setIsAdmin] = useState<boolean>(false);

    const [listApprovers, setListApprovers] = useState<any>([]);
    const [addApprover, setAddApprover] = useState<number>(null!);

    // função para pesquisar dados do centro de custo
    const getData = async () => {

        setLoading(true);

        await ManagersCostCentersShowService(parseInt(id!)).then(resp => {
            setCostCenter(resp.data.costCenter);
            setApprovers(resp.data.approvers);
            setIsAdmin(resp.data.is_admin);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        await ManagersCostCentersApproversService(parseInt(id!)).then(resp => {
            setListApprovers(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar dados do centro de custo

    // função para adicionar aprovador
    const createApprover = async (e: FormEvent<HTMLFormElement>, level: number) => {

        e.preventDefault();

        if (addApprover == null) {
            ToastErro('Selecione um aprovador!');
            return;
        }

        (window as any).$("#modalAddApprover" + (level - 1)).modal("hide");

        setLoading(true);

        await ManagersCostCentersCreateApproverService(parseInt(id!), addApprover, level).then(resp => {
            ToastSucesso(resp.data.message);
            setAddApprover(null!);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para adicionar aprovador

    // função para desativar/ativar aprovador
    const deleteApprover = async (user: number, index: number) => {

        (window as any).$("#modalDelete" + (user + index)).modal('hide');

        setLoading(true);

        await ManagersApproversDeleteService(parseInt(id!), user, (index + 1)).then(resp => {
            ToastSucesso(resp.data.message);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para desativar/ativar aprovador

    // função para adicionar nivel
    const addLevel = async () => {

        (window as any).$("#modalAddLevel").modal("hide")

        setLoading(true);

        await MnaagersCostCentersAddLevelService(parseInt(id!)).then(resp => {
            ToastSucesso(resp.data.message);
            getData();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        });

    }
    // função para adicionar nivel

    const removeLevel = async () => {

        (window as any).$("#modalremoveLevel").modal('hide');

        setLoading(true);

        await MnaagersCostCentersRemoveLevelService(parseInt(id!)).then(resp => {
            ToastSucesso(resp.data.message);
            getData();
        });

    }

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <HeaderComponent
                title="Informações do Centro de Custo"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/managers/cost_centers')}
                button2={isAdmin ? "Adicionar Nível" : undefined}
                onClick2={isAdmin ? () => (window as any).$("#modalAddLevel").modal("show") : undefined}
                iconButton2={isAdmin ? "add" : undefined}
                button3={isAdmin ? "Remover Nível" : undefined}
                iconButton3={isAdmin ? "remove" : undefined}
                onClick3={isAdmin ? () => (window as any).$("#modalremoveLevel").modal('show') : undefined}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Informações Gerais"
                    >
                        {
                            loading

                                ?

                                <LoadingComponent />

                                :

                                <>
                                    <div className="row">
                                        <InputComponent
                                            label="ID"
                                            col={3}
                                            size={"small"}
                                            defaultValue={costCenter?.id}
                                            disabled
                                        />
                                        <InputComponent
                                            label="Descrição"
                                            col={3}
                                            size={"small"}
                                            defaultValue={costCenter?.description}
                                            disabled
                                        />
                                        <InputComponent
                                            label="Filial"
                                            col={3}
                                            size={"small"}
                                            defaultValue={costCenter?.branch}
                                            disabled
                                        />
                                        <InputComponent
                                            label="Qtd. Níveis de Aprovação"
                                            col={3}
                                            size={"small"}
                                            defaultValue={costCenter?.approval_levels}
                                            disabled
                                        />
                                    </div>
                                </>
                        }
                    </CardHeaderBackgroundComponent>
                    <div className="d-flex justify-content-between align-items-end">
                        <h2 className="display-6 mb-0">Níveis de Aprovação</h2>
                    </div>
                    <div className="row mt-4">
                        {
                            approvers.map((a: any, index: number) => {
                                return (
                                    <div className="col-md-6" key={index}>
                                        <TableComponent
                                            title={`Aprovadores ${index + 1}º Nível`}
                                            columns={isAdmin ? ['ID', 'Nome', 'Ativo', 'Ações'] : ['ID', 'Nome', 'Ativo']}
                                            loading={loading}
                                            button={isAdmin ? "Aprovador" : undefined}
                                            iconButton={isAdmin ? 'add' : undefined}
                                            onClick={isAdmin ? () => (window as any).$("#modalAddApprover" + index).modal('show') : undefined}
                                        >
                                            {
                                                a.map((ap: any, indexAP: number) => {
                                                    return (
                                                        <tr key={indexAP}>
                                                            <td className="px-4">{ap.id}</td>
                                                            <td className="px-4">{ap.name}</td>
                                                            <td className="px-4">
                                                                {
                                                                    ap.active == 1

                                                                        ?

                                                                        <h6><span className="badge bg-success">Sim</span></h6>

                                                                        :

                                                                        <h6><span className="badge bg-danger">Não</span></h6>
                                                                }
                                                            </td>
                                                            {isAdmin && <td className="px-4">
                                                                <button className="btn btn-text-danger" type="button" title={"Excluir"} onClick={() => (window as any).$("#modalDelete" + (ap.id + index)).modal('show')}><i className="material-icons">{ap.active == 1 ? 'delete' : 'upload'}</i></button>

                                                                <ModalComponent
                                                                    title={"Excluir Aprovador"}
                                                                    id={`modalDelete${ap.id + index}`}
                                                                >
                                                                    <>
                                                                        <p>Você tem certeza que deseja excluir o aprovador abaixo?</p>
                                                                        <table className="table">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>ID:</td>
                                                                                    <td>{ap.id}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td>Nome:</td>
                                                                                    <td>{ap.name}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>

                                                                        <div className="d-flex justify-content-end mt-4">
                                                                            <button className="btn btn-primary" type="button" onClick={() => deleteApprover(ap.id, index)}>Excluir</button>
                                                                        </div>
                                                                    </>
                                                                </ModalComponent>
                                                            </td>}
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </TableComponent>

                                        <ModalComponent
                                            title={`Adicionar Aprovador ${index + 1}º Nível`}
                                            id={`modalAddApprover${index}`}
                                        >
                                            <form onSubmit={(e: FormEvent<HTMLFormElement>) => createApprover(e, index + 1)}>
                                                <div className="row mt-4">
                                                    <div className="col-md-12">
                                                        <FormControl fullWidth>
                                                            <InputLabel>Aprovador</InputLabel>
                                                            <Select
                                                                label="Aprovador"
                                                                value={addApprover}
                                                                onChange={(e: any) => setAddApprover(e.target.value)}
                                                                required
                                                            >
                                                                {
                                                                    listApprovers.map((l: any) => {
                                                                        return <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>;
                                                                    })
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-4">
                                                    <button className="btn btn-primary" type="submit">Adicionar</button>
                                                </div>
                                            </form>
                                        </ModalComponent>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <ModalComponent
                        title="Adicionar Nível de Aprovação"
                        id="modalAddLevel"
                    >
                        <>
                            <p className="mt-4 mb-4">Você tem certeza que deseja adiocionar um nível de aprovação</p>

                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="button" onClick={addLevel}>Adicionar</button>
                            </div>
                        </>
                    </ModalComponent>

                    <ModalComponent
                        title="Remover Nível de Aprovação"
                        id="modalremoveLevel"
                    >
                        <>
                            <p>Você tem certeza que deseja remover um nível de aprovação?</p>
                            <div className="d-flex justify-content-end mt-4">
                                <button className="btn btn-primary" type="button" onClick={removeLevel}>Remover</button>
                            </div>
                        </>
                    </ModalComponent>
                </>
            </ContainerComponent>
        </>
    );

}

export default ManagersCostCentersInfoPage;